import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppResolver } from './app.resolver';
import { AccessNotGrantedComponent } from './core/components/access-not-granted/access-not-granted.component';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './modules/login/login.component';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { ServiceUnavailableComponent } from './core/components/service-unavailable/service-unavailable.component';

export const routes: Routes = [
  // main routes
  {
    path: ':companyName',
    component: LayoutComponent,
    resolve: {
      initialData: AppResolver,
    },
    children: [
      {
        path: 'search',
        loadChildren: () =>
          import('./modules/searcher/searcher.module').then(
            (m) => m.SearcherModule
          ),
      },
      {
        path: 'inquire',
        loadChildren: () =>
          import('./modules/forms-inquire/forms-inquire.module').then(
            (m) => m.FormsInquireModule
          ),
      },
      {
        path: 'charter',
        loadChildren: () =>
          import('./modules/forms-inquire/forms-inquire.module').then(
            (m) => m.FormsInquireModule
          ),
      },
      {
        path: 'cruise',
        loadChildren: () =>
          import('./modules/cruise-profile/cruise-profile.module').then(
            (m) => m.CruiseProfileModule
          ),
      },
      {
        path: 'checkout',
        loadChildren: () =>
          import('./modules/checkout/checkout.module').then(
            (m) => m.CheckoutModule
          ),
      },
      {
        path: 'thanks',
        loadChildren: () =>
          import('./modules/thanks/thanks.module').then(
            (m) => m.ThanksModule
          ),
      },
      {
        path: 'wishlist',
        loadChildren: () =>
          import('./modules/wish-list/wish-list.module').then(
            (m) => m.WishListModule
          ),
      },
      {
        path: 'compare',
        loadChildren: () =>
          import('./modules/compare/compare.module').then(
            (m) => m.CompareModule
          ),
      },
      {
        path: 'trip-planner',
        loadChildren: () =>
          import('./modules/trip-planner/trip-planner.module').then(
            (m) => m.TripPlannerModule
          ),
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: "404",
        component: NotFoundComponent,
      },
      {
        path: "403",
        component: AccessNotGrantedComponent,
      },
      {
        path: "503",
        component: ServiceUnavailableComponent,
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'search',
      },
      {
        path: '**',
        redirectTo: 'search',
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
